import { useNavigate } from 'react-router-dom';
import { Card, Divider, EmptyState, Icon, Skeleton, TextButton } from '../../components';
import { MAX_CARD_WIDTH } from '../../constants';
import { useGetCandidatesQuery } from '../../services';
import HiringTableRow from './HiringTableRow';

const NUM_LOADING_SKELETONS = 3;

const Hiring = () => {
  const navigate = useNavigate();

  const { data: candidates = [], isLoading } = useGetCandidatesQuery();

  if (isLoading) {
    return (
      <>
        {Array.from({ length: NUM_LOADING_SKELETONS }, (_, index) => (
          <div key={index}>
            <div className="flex justify-between py-4">
              <Skeleton />
            </div>
            {index < NUM_LOADING_SKELETONS - 1 && <Divider />}
          </div>
        ))}
      </>
    );
  }

  if (!candidates.length) {
    return (
      <EmptyState
        description="Your organization has no candidates at the moment."
        ctaButtonProps={{ text: 'Create new candidate', onClick: () => navigate('create') }}
      />
    );
  }
  return (
    <div className="flex h-full w-full flex-col gap-4">
      <TextButton text="Create new" className="ml-auto" startIcon={Icon.PLUS} onClick={() => navigate('create')} />
      <Card maxWidth={MAX_CARD_WIDTH} className="mx-auto">
        {candidates.map(({ candidateId, ...candidate }, index) => (
          <div key={candidateId}>
            <HiringTableRow candidateId={candidateId} {...candidate} />
            {index < candidates.length - 1 && <Divider />}
          </div>
        ))}
      </Card>
    </div>
  );
};

export default Hiring;
